import React, { Suspense } from 'react'
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import ScrollToTop from './hooks/ScrollToTop'
import * as view from './view'
import * as ROUTES from './constant/routes'
import * as layout from './component/layout'
import { floatingComponent } from './component/common/floatingComponent';

function App() {
  return (
    <Router>
      <Suspense>
            <Routes>
                <Route path={ROUTES.Home} element={
                    <ScrollToTop>
                            <view.Home />
                    </ScrollToTop>
                } />
            </Routes>
        </Suspense>
    </Router>
  );
}

export default App;
